import styled from 'styled-components';
import { colors, fontSize, fontWeight } from '../../theme';

export const SelectedQuestionsContainerStyled = styled.div`
    flex: 1;
    overflow-y: auto;
    padding-right: 4px;
    &::-webkit-scrollbar {
        width: 2px;
        background-color: ${colors.grey500};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${colors.grey400};
    }
`;

export const SelectedQuestionItemStyled = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 6px;
    margin-bottom: 4px;
    background-color: ${colors.grey700};
    border: 1px solid ${colors.grey500};
`;

export const SelectedQuestionInputStyled = styled.input`
    flex: 1;
    border: none;
    background: transparent;
    font-family: Barlow, sans-serif;
    font-size: ${fontSize.s};
    font-weight: ${fontWeight.regular};
    color: ${colors.grey100};
    outline: none;
    min-width: 0;
    &:focus {
        background-color: ${colors.grey600};
        border-radius: 4px;
        padding: 2px 4px;
    }
`;

export const SelectedQuestionHeaderStyled = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colors.grey500};
`;

export const DragHandleStyled = styled.div`
    cursor: grab;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    &:active {
        cursor: grabbing;
    }
`;
